<template>
  <div class="container" v-bind="$attrs">
    <slot />
  </div>
</template>

<script setup></script>
